<template>
  <div class="card-form">
    <div id="card-number"></div>
    <div class="flex">
      <div id="card-expiry"></div>
      <div id="card-cvc"></div>
    </div>
    <div id="card-error"></div>
  </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js'

export default {
  props: {
    onValidationChange: {
      type: Function,
      required: true
    },
    isSubscription: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      stripe: null,
      elements: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      token: null,
      isCardNumberComplete: false,
      isCardExpiryComplete: false,
      isCardCvcComplete: false
    }
  },
  computed: {
    isFormValid () {
      return this.isCardNumberComplete && this.isCardExpiryComplete && this.isCardCvcComplete
    }
  },
  watch: {
    isFormValid (newValue) {
      // 親コンポーネントに状態を通知
      this.onValidationChange(newValue)
    }
  },
  async mounted () {
    try {
      this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY)
      if (!this.stripe) {
        console.error('Stripeの初期化に失敗しました。公開鍵を確認してください。')
        return
      }

      this.elements = this.stripe.elements()

      const style = {}

      this.cardNumber = this.elements.create('cardNumber', { style })
      this.cardNumber.mount('#card-number')
      this.cardNumber.on('change', this.handleCardChange)

      this.cardExpiry = this.elements.create('cardExpiry', { style })
      this.cardExpiry.mount('#card-expiry')
      this.cardExpiry.on('change', this.handleCardChange)

      this.cardCvc = this.elements.create('cardCvc', { style })
      this.cardCvc.mount('#card-cvc')
      this.cardCvc.on('change', this.handleCardChange)
    } catch (error) {
      console.error('初期化中にエラーが発生しました:', error)
    }
  },
  beforeDestroy () {
    if (this.cardNumber) this.cardNumber.destroy()
    if (this.cardExpiry) this.cardExpiry.destroy()
    if (this.cardCvc) this.cardCvc.destroy()
  },
  methods: {
    handleCardChange (event) {
      if (event.elementType === 'cardNumber') {
        this.isCardNumberComplete = event.complete
      } else if (event.elementType === 'cardExpiry') {
        this.isCardExpiryComplete = event.complete
      } else if (event.elementType === 'cardCvc') {
        this.isCardCvcComplete = event.complete
      }

      if (event.error) {
        document.getElementById('card-error').innerHTML = event.error.message
      } else {
        document.getElementById('card-error').innerHTML = ''
      }
    },
    async createToken () {
      console.log('トークンを作成します...')
      try {
        const { token, error } = await this.stripe.createToken(this.cardNumber)
        if (error) {
          document.getElementById('card-error').innerHTML = error.message
          console.error('トークン作成エラー:', error.message)
          return
        }
        this.token = token.id
        console.log('トークン生成成功:', token)
        this.tokenCreated(token)
      } catch (error) {
        console.error('トークン作成中にエラーが発生しました:', error)
      }
    },
    createSubscription (token) {
      console.log('サブスクリプションを作成します...')
      this.isPaymentYagiprime = false
      this.$eventHub.$emit('loading_on')
      this.token = ''
      if (token) {
        this.token = token.id
      }
      const formData = new FormData()
      formData.append('stripe_token', this.token)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('subscription_type', 1)
      //  無料キャンペーンの受付を考える
      // if (app.isCampaign) {
      //   formData.append('trial_campaign_id', app.trial_campaign_id)
      // }

      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')
      formData.append('payment_method', 'card')
      this.fullscreenLoading = true
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.subscription, formData, { timeout: 60000 })
        .then(function (response) {
          console.log('サブスクリプション作成成功:', response)
          console.log(response.status)

          if (response.status === 201) {
            console.log('サブスクリプション作成成功')
            const subformData = new FormData()

            var routeId = app.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
            if (routeId) {
              subformData.append('route', routeId)
            } else {
              subformData.append('route', '')
            }
            subformData.append('uuid', app.$firebase.user.uid)
            app.$axios
              .post(app.$varuna.endPoints.setYagiprimeEntrySource, subformData, { timeout: 60000 })
          }
        })
        .catch(function (error) {
          console.error('サブスクリプション作成エラー:', error)
          app.$eventHub.$emit('payment_yagiprime_result', 'error')
        }).finally(() => {
          app.$eventHub.$emit('loading_off')
          // 現在のページをリロード
          // app.$router.go()
        })
    },
    tokenCreated (token) {
      if (this.isSubscription) {
        this.createSubscription(token)
      } else {
        this.createPayment(token)
      }
    }
  }
}
</script>

<style>
/*クレカフォーム*/
.card-form .StripeElement {
  background: #fff;
  border: 1px solid #dfdfdf;
  border-radius: 10px;
  margin: 10px 0;
  padding: 12px;
  margin-bottom: 10px;
}
.card-form .flex .StripeElement {
  width: calc(50% - 5px);
}
.card-form .flex {
  display: flex;
  justify-content: space-between;
}
</style>
